<template>
  <div>
    <modify-table ref="order" @clearDetails="clearDetails" @showDetails="showDetails"/>
    <modify-detail ref="details"/>
  </div>
</template>

<script>
import ModifyTable from '@/views/inbound/modify/ModifyTable.vue'
import ModifyDetail from '@/views/inbound/modify/ModifyDetail.vue'

export default {
    name: 'Modify',
    components: {ModifyDetail, ModifyTable},
    data() {
      return {}
    },
    methods: {
      refresh() {
        this.$refs.order.refresh()
      },
      showDetails(row) {
        this.$refs.details.refresh(row.order.id)
      },
      clearDetails() {
        this.$refs.details.clear()
      }
    }
  }
</script>